var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ContentLayout", {
    attrs: {
      title: _vm.iSEdited
        ? _vm.$t("label_essweb_leaveTypePropertyGroup_form_editTitle")
        : _vm.$t("label_essweb_leaveTypePropertyGroup_form_viewTitle"),
      delBtn: "",
      editBtn: !_vm.iSEdited,
      initData: _vm.PHGroupData,
      checkData: [
        "leave_type_property_group_name",
        "leave_type_property_group_description",
        "leave_type_property_group_code",
        "remarks",
      ],
      pad: "0",
      widthClass: "max-1000",
    },
    on: {
      change: function (changed) {
        return (_vm.isChanged = changed)
      },
      edit: function ($event) {
        _vm.iSEdited = true
      },
      delete: function ($event) {
        _vm
          .$confirmDo(_vm.$t("label_essweb_leaveTypePropertyGroup_list_title"))
          .then(function (res) {
            res ? _vm.toDelete() : null
          })
      },
    },
    scopedSlots: _vm._u([
      {
        key: "page-main",
        fn: function () {
          return [
            _c("Taber", {
              attrs: { curTab: _vm.curTab, items: _vm.taber },
              on: {
                change: function (tab) {
                  return (_vm.curTab = tab)
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "content-1",
                  fn: function () {
                    return [
                      _c(
                        "v-form",
                        { ref: "form", attrs: { "lazy-validation": "" } },
                        [
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "12",
                                    md: "12",
                                    lg: "12",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("inputTextFiledMultiLang", {
                                    attrs: {
                                      filled: _vm.iSEdited,
                                      readonly: !_vm.iSEdited,
                                      maxlength: "100",
                                      bindData:
                                        _vm.PHGroupData
                                          .leave_type_property_group_name,
                                      label: _vm.$t(
                                        "label_essweb_leaveTypePropertyGroup_form_groupNameLabel"
                                      ),
                                      rules: _vm.$GetRules(
                                        ["_Require_Rules"],
                                        [null]
                                      ),
                                    },
                                    on: {
                                      change: function (valueArr) {
                                        _vm.PHGroupData.leave_type_property_group_name =
                                          valueArr
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "12",
                                    md: "12",
                                    lg: "12",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("inputTextFiledMultiLang", {
                                    attrs: {
                                      filled: _vm.iSEdited,
                                      maxlength: "500",
                                      readonly: !_vm.iSEdited,
                                      bindData:
                                        _vm.PHGroupData
                                          .leave_type_property_group_description,
                                      label: _vm.$t(
                                        "label_essweb_leaveTypePropertyGroup_form_descriptionLabel"
                                      ),
                                    },
                                    on: {
                                      change: function (valueArr) {
                                        _vm.PHGroupData.leave_type_property_group_description =
                                          valueArr
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "12",
                                    md: "12",
                                    lg: "12",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("normalInputTextFiled", {
                                    attrs: {
                                      filled: _vm.iSEdited,
                                      readonly: !_vm.iSEdited,
                                      maxlength: "500",
                                      rules: _vm.$GetRules(
                                        ["_Require_Rules"],
                                        [null]
                                      ),
                                      label: _vm.$t(
                                        "label_essweb_leaveTypePropertyGroup_form_codeLabel"
                                      ),
                                    },
                                    model: {
                                      value:
                                        _vm.PHGroupData
                                          .leave_type_property_group_code,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.PHGroupData,
                                          "leave_type_property_group_code",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "PHGroupData.leave_type_property_group_code",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "12",
                                    md: "12",
                                    lg: "12",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c(
                                    "v-sheet",
                                    { staticClass: "text--secondary" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "label_essweb_leaveTypePropertyGroup_form_remarkLabel"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _c("v-textarea", {
                                    attrs: {
                                      rows: "5",
                                      "no-resize": "",
                                      maxlength: "500",
                                      dense: "",
                                      counter: "500",
                                      filled: _vm.iSEdited,
                                      "single-line": "",
                                      readonly: !_vm.iSEdited,
                                      name: "input-7-4",
                                    },
                                    model: {
                                      value: _vm.PHGroupData.remarks,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.PHGroupData,
                                          "remarks",
                                          $$v
                                        )
                                      },
                                      expression: "PHGroupData.remarks",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "content-2",
                  fn: function () {
                    return [
                      _c("PropertyList", {
                        attrs: {
                          items: _vm.desserts,
                          listdata: _vm.PropertyListData,
                          canEdit: _vm.iSEdited,
                        },
                        on: {
                          edit: function (obj) {
                            _vm.viewProperty = false
                            _vm.toEditProperty(obj)
                          },
                          view: function (obj) {
                            _vm.viewProperty = true
                            _vm.toEditProperty(obj)
                          },
                        },
                      }),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "page-actions",
        fn: function () {
          return [
            _vm.iSEdited && _vm.curTab == "tab-1"
              ? _c("CardActions", {
                  attrs: { saveBtn: _vm.curTab == "tab-1" },
                  on: {
                    save: _vm.toSave,
                    cancel: function ($event) {
                      return _vm.$toBack(_vm.isChanged)
                    },
                  },
                })
              : _vm._e(),
          ]
        },
        proxy: true,
      },
      {
        key: "tools-main",
        fn: function () {
          return [
            _c("EditMappingPopup4", {
              attrs: {
                show: _vm.showMappingPopup,
                PropertyData: _vm.PropertyData,
                curGroupId: _vm.$route.params.id,
                view: _vm.viewProperty,
              },
              on: {
                close: function ($event) {
                  _vm.showMappingPopup = false
                  _vm.PropertyData = null
                },
                confirm: _vm.onEditProperty,
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }